// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"d46e2e3c","56":"9960d847","667":"a647885c"}[chunkId] + ".chunk.js";
};